/* NEXRA 17/09 (gio VN) — BAN XEM TRUOC v2. Swatch mau tren the san pham.
   - Desktop: re chuot vao o -> doi anh the + doi dau "dang chon"; roi chuot -> tra ve nhu cu.
   - Cam ung: cham lan 1 doi anh, cham lan 2 vao DUNG o do moi di tiep.
   - O cua chinh mau dang xem (listing mau) co data-nx-sw-self -> bam KHONG lam gi.
   Go: xoa file nay + snippets/nx-card-swatch.liquid + dong render trong card-product.liquid
       + khoi .nx-sw* cuoi nexra-brand.css + the script trong theme.liquid. */
(function () {
  if (window.__nxSwatch2) return;
  window.__nxSwatch2 = 1;

  var chamDuoc = window.matchMedia && window.matchMedia('(hover: none)').matches;

  function theCua(el) {
    return el.closest('.card-wrapper') || el.closest('.card');
  }
  function anhThe(el) {
    var card = theCua(el);
    if (!card) return null;
    return card.querySelector('.card__media img');
  }
  function doiAnh(hang, url) {
    var img = anhThe(hang);
    if (!img || !url) return;
    if (img.dataset.nxGoc === undefined) {
      img.dataset.nxGoc = img.getAttribute('src') || '';
      img.dataset.nxGocSet = img.getAttribute('srcset') || '';
    }
    img.removeAttribute('srcset');
    img.setAttribute('src', url);
  }
  function traAnh(hang) {
    var img = anhThe(hang);
    if (!img || img.dataset.nxGoc === undefined) return;
    img.setAttribute('src', img.dataset.nxGoc);
    if (img.dataset.nxGocSet) img.setAttribute('srcset', img.dataset.nxGocSet);
  }
  function danhDau(hang, item) {
    var ds = hang.querySelectorAll('.nx-sw__item');
    for (var i = 0; i < ds.length; i++) ds[i].classList.remove('is-active');
    if (item) item.classList.add('is-active');
  }
  /* PHAN L 18/09: HAI DAU RIENG.
     is-active = o DANG CHON THAT (Liquid render, desktop KHONG bao gio doi).
     is-xem    = o dang xem truoc khi re chuot (chi desktop).
     Truoc day desktop gan is-active sang o dang re nen o dang chon mat vong den. */
  function danhDauXem(hang, item) {
    var ds = hang.querySelectorAll('.nx-sw__item');
    for (var i = 0; i < ds.length; i++) ds[i].classList.remove('is-xem');
    if (item) item.classList.add('is-xem');
  }

  document.addEventListener('mouseover', function (e) {
    if (chamDuoc || !e.target.closest) return;
    var a = e.target.closest('.nx-sw__item');
    if (!a) return;
    var hang = a.closest('.nx-sw');
    // Re vao chinh o dang chon: anh the von da la anh do, khong doi gi, va bo dau xem truoc.
    if (a.classList.contains('is-active')) { danhDauXem(hang, null); return; }
    doiAnh(hang, a.getAttribute('data-nx-sw-img'));
    danhDauXem(hang, a);
  });

  document.addEventListener('mouseleave', function (e) {
    if (chamDuoc || !e.target.closest) return;
    var hang = e.target.closest('.nx-sw');
    if (!hang) return;
    traAnh(hang);
    danhDauXem(hang, null);
  }, true);

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var a = e.target.closest('.nx-sw__item');
    if (!a) return;

    // O cua chinh mau dang xem: khong dieu huong, khong doi gi.
    if (a.hasAttribute('data-nx-sw-self')) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    if (!chamDuoc) return;

    // Cam ung: lan cham dau chi doi anh, lan cham thu hai moi di tiep.
    if (a.classList.contains('is-active')) return;
    e.preventDefault();
    e.stopPropagation();
    var hang = a.closest('.nx-sw');
    doiAnh(hang, a.getAttribute('data-nx-sw-img'));
    danhDau(hang, a);
  }, true);
})();
